import { render, staticRenderFns } from "./AppError.vue?vue&type=template&id=089b8829&"
import script from "./AppError.vue?vue&type=script&lang=js&"
export * from "./AppError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports